import { Typography } from '@snack-uikit/typography';

import { Condition } from '@/components/static';
import { equals } from '@/utils/common';

import { PlatformIcon } from '../icons';
import s from './styles.module.scss';

type SelectedProps = {
  length: number;
  optionName: string;
  idx: number;
  lastVisibleSelectedItemIndex: number;
};

const getLabelText = ({ length, optionName, idx, lastVisibleSelectedItemIndex }: SelectedProps) => {
  if (equals(idx, lastVisibleSelectedItemIndex)) return `${optionName.slice(0, 4)}...`;
  if (idx < length && length > 1) return `${optionName},`;
  return optionName;
};

export function SelectedOption({ length, optionName, idx, lastVisibleSelectedItemIndex }: SelectedProps) {
  if (idx > lastVisibleSelectedItemIndex) return null;

  const isLengthEqualsOne = equals(length, 1);
  return (
    <div className={s.selected_option_wrapper}>
      <PlatformIcon platform={optionName} isLarge={isLengthEqualsOne} />
      <div className={s.selected_name_with_label}>
        <Condition when={isLengthEqualsOne}>
          <Typography.SansBodyS className={s.option_label}>Облачная платформа</Typography.SansBodyS>
        </Condition>
        <Typography.SansLabelL className={s.selected_option_text}>
          {getLabelText({ length, optionName, idx, lastVisibleSelectedItemIndex })}
        </Typography.SansLabelL>
      </div>
    </div>
  );
}
